import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AuthContext from '../../components/shared/AuthContext';

export default function TeamAuditPage() {
  const { orgId } = useParams();
  const { apiClient } = useContext(AuthContext);
  const [page, setPage] = useState({ content: [], totalPages: 0 });
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiClient.get(`/api/organizations/${orgId}/audit-logs`, { params: { page: 0, size: 30 } });
        if (!cancelled) {
          const data = res.data;
          if (Array.isArray(data)) setPage({ content: data, totalPages: 1 });
          else setPage(data || { content: [] });
        }
      } catch {
        if (!cancelled) setError('Audit log unavailable for your role.');
      }
    })();
    return () => { cancelled = true; };
  }, [apiClient, orgId]);

  const rows = page.content || page.items || (Array.isArray(page) ? page : []);

  return (
    <div className="teams-card">
      <h2>Audit log</h2>
      <p className="teams-sub">Security-relevant organization events (invites, roles, settings, content).</p>
      {error && <div className="teams-error" role="alert">{error}</div>}
      <div className="teams-table-wrap">
        <table className="teams-table">
          <thead>
            <tr>
              <th>When</th>
              <th>Action</th>
              <th>Target</th>
              <th>Actor</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id || `${row.createdAt}-${row.action}`}>
                <td>{row.createdAt ? new Date(row.createdAt).toLocaleString() : '—'}</td>
                <td>{row.action}</td>
                <td>{row.targetType ? `${row.targetType} ${row.targetId || ''}` : '—'}</td>
                <td>{row.actorUserId ?? row.actorId ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {page.totalPages > 1 && (
        <p className="teams-sub">More pages available — pagination coming soon.</p>
      )}
    </div>
  );
}
